import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useAppVersionCheck } from '../../hooks/useAppVersionCheck.js'
import { refreshApp, subscribeToAppUpdate } from '../../utils/appUpdateState.js'
import './UpdateBanner.css'

const UpdateBanner = () => {
  const { t } = useTranslation()
  const [visible, setVisible] = useState(false)

  useAppVersionCheck()

  useEffect(() => {
    return subscribeToAppUpdate(setVisible)
  }, [])

  if (!visible) return null

  return (
    <div className="update-prompt" role="status" aria-live="polite">
      <p className="update-prompt__message">{t('app.updateAvailable')}</p>
      <button type="button" className="update-prompt__refresh" onClick={refreshApp}>
        {t('app.refreshApp')}
      </button>
    </div>
  )
}

export default UpdateBanner
